// gets a mapping of the region labels from the /regions api response
export function getRegionLabels(regions) {
  const regionLabels = {};
  regions.forEach((region) => {
    regionLabels[region.region] = region.label;
  });
  return regionLabels;
}
